webpackJsonp([35783957827783],{

/***/ 705:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/* **********************************************
	     Begin prism-core.js
	********************************************** */
	
	var _self = (typeof window !== 'undefined')
		? window   // if in browser
		: (
			(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
		);
	
	/**
	 * Prism: Lightweight, robust, elegant syntax highlighting
	 * MIT license http://www.opensource.org/licenses/mit-license.php/
	 * @author Lea Verou http://lea.verou.me
	 */
	
	var Prism = (function(){
	
	// Private helper vars
	var lang = /\blang(?:uage)?-([\w-]+)\b/i;
	var uniqueId = 0;
	
	var _ = _self.Prism = {
		manual: _self.Prism && _self.Prism.manual,
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
		util: {
			encode: function (tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
				} else if (_.util.type(tokens) === 'Array') {
					return tokens.map(_.util.encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},
	
			type: function (o) {
				return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
			},
	
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},
	
			// Deep clone a language definition (e.g. to extend it)
			clone: function (o, visited) {
				var type = _.util.type(o);
				visited = visited || {};
	
				switch (type) {
					case 'Object':
						if (visited[_.util.objId(o)]) {
							return visited[_.util.objId(o)];
						}
						var clone = {};
						visited[_.util.objId(o)] = clone;
	
						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = _.util.clone(o[key], visited);
							}
						}
	
						return clone;
	
					case 'Array':
						if (visited[_.util.objId(o)]) {
							return visited[_.util.objId(o)];
						}
						var clone = [];
						visited[_.util.objId(o)] = clone;
	
						o.forEach(function (v, i) {
							clone[i] = _.util.clone(v, visited);
						});
	
						return clone;
				}
	
				return o;
			}
		},
	
		languages: {
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);
	
				for (var key in redef) {
					lang[key] = redef[key];
				}
	
				return lang;
			},
	
			/**
			 * Insert a token before another token in a language literal
			 * As this needs to recreate the object (we cannot actually insert before keys in object literals),
			 * we cannot just provide an object, we need anobject and a key.
			 * @param inside The key (or language id) of the parent
			 * @param before The key to insert before. If not provided, the function appends instead.
			 * @param insert Object with the key/value pairs to insert
			 * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || _.languages;
				var grammar = root[inside];
	
				if (arguments.length == 2) {
					insert = arguments[1];
	
					for (var newToken in insert) {
						if (insert.hasOwnProperty(newToken)) {
							grammar[newToken] = insert[newToken];
						}
					}
	
					return grammar;
				}
	
				var ret = {};
	
				for (var token in grammar) {
	
					if (grammar.hasOwnProperty(token)) {
	
						if (token == before) {
	
							for (var newToken in insert) {
	
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}
	
						ret[token] = grammar[token];
					}
				}
	
				// Update references in other language definitions
				_.languages.DFS(_.languages, function(key, value) {
					if (value === root[inside] && key != inside) {
						this[key] = ret;
					}
				});
	
				return root[inside] = ret;
			},
	
			// Traverse a language definition with Depth First Search
			DFS: function(o, callback, type, visited) {
				visited = visited || {};
				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);
	
						if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
							visited[_.util.objId(o[i])] = true;
							_.languages.DFS(o[i], callback, null, visited);
						}
						else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
							visited[_.util.objId(o[i])] = true;
							_.languages.DFS(o[i], callback, i, visited);
						}
					}
				}
			}
		},
		plugins: {},
	
		highlightAll: function(async, callback) {
			_.highlightAllUnder(document, async, callback);
		},
	
		highlightAllUnder: function(container, async, callback) {
			var env = {
				callback: callback,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};
	
			_.hooks.run("before-highlightall", env);
	
			var elements = env.elements || container.querySelectorAll(env.selector);
	
			for (var i=0, element; element = elements[i++];) {
				_.highlightElement(element, async === true, env.callback);
			}
		},
	
		highlightElement: function(element, async, callback) {
			// Find language
			var language, grammar, parent = element;
	
			while (parent && !lang.test(parent.className)) {
				parent = parent.parentNode;
			}
	
			if (parent) {
				language = (parent.className.match(lang) || [,''])[1].toLowerCase();
				grammar = _.languages[language];
			}
	
			// Set language on the element, if not present
			element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
	
			if (element.parentNode) {
				// Set language on the parent, for styling
				parent = element.parentNode;
	
				if (/pre/i.test(parent.nodeName)) {
					parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
				}
			}
	
			var code = element.textContent;
	
			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};
	
			_.hooks.run('before-sanity-check', env);
	
			if (!env.code || !env.grammar) {
				if (env.code) {
					_.hooks.run('before-highlight', env);
					env.element.textContent = env.code;
					_.hooks.run('after-highlight', env);
				}
				_.hooks.run('complete', env);
				return;
			}
	
			_.hooks.run('before-highlight', env);
	
			if (async && _self.Worker) {
				var worker = new Worker(_.filename);
	
				worker.onmessage = function(evt) {
					env.highlightedCode = evt.data;
	
					_.hooks.run('before-insert', env);
	
					env.element.innerHTML = env.highlightedCode;
	
					callback && callback.call(env.element);
					_.hooks.run('after-highlight', env);
					_.hooks.run('complete', env);
				};
	
				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			}
			else {
				env.highlightedCode = _.highlight(env.code, env.grammar, env.language);
	
				_.hooks.run('before-insert', env);
	
				env.element.innerHTML = env.highlightedCode;
	
				callback && callback.call(element);
	
				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
			}
		},
	
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},
	
		matchGrammar: function (text, strarr, grammar, index, startPos, oneshot, target) {
			var Token = _.Token;
	
			for (var token in grammar) {
				if(!grammar.hasOwnProperty(token) || !grammar[token]) {
					continue;
				}
	
				if (token == target) {
					return;
				}
	
				var patterns = grammar[token];
				patterns = (_.util.type(patterns) === "Array") ? patterns : [patterns];
	
				for (var j = 0; j < patterns.length; ++j) {
					var pattern = patterns[j],
						inside = pattern.inside,
						lookbehind = !!pattern.lookbehind,
						greedy = !!pattern.greedy,
						lookbehindLength = 0,
						alias = pattern.alias;
	
					if (greedy && !pattern.pattern.global) {
						// Without the global flag, lastIndex won't work
						var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
						pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
					}
	
					pattern = pattern.pattern || pattern;
	
					// Don’t cache length as it changes during the loop
					for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {
	
						var str = strarr[i];
	
						if (strarr.length > text.length) {
							// Something went terribly wrong, ABORT, ABORT!
							return;
						}
	
						if (str instanceof Token) {
							continue;
						}
	
						if (greedy && i != strarr.length - 1) {
							pattern.lastIndex = pos;
							var match = pattern.exec(text);
							if (!match) {
								break;
							}
	
							var from = match.index + (lookbehind ? match[1].length : 0),
							    to = match.index + match[0].length,
							    k = i,
							    p = pos;
	
							for (var len = strarr.length; k < len && (p < to || (!strarr[k].type && !strarr[k - 1].greedy)); ++k) {
								p += strarr[k].length;
								// Move the index i to the element in strarr that is closest to from
								if (from >= p) {
									++i;
									pos = p;
								}
							}
	
							// If strarr[i] is a Token, then the match starts inside another Token, which is invalid
							if (strarr[i] instanceof Token) {
								continue;
							}
	
							// Number of tokens to delete and replace with the new match
							delNum = k - i;
							str = text.slice(pos, p);
							match.index -= pos;
						} else {
							pattern.lastIndex = 0;
	
							var match = pattern.exec(str),
								delNum = 1;
						}
	
						if (!match) {
							if (oneshot) {
								break;
							}
	
							continue;
						}
	
						if(lookbehind) {
							lookbehindLength = match[1] ? match[1].length : 0;
						}
	
						var from = match.index + lookbehindLength,
						    match = match[0].slice(lookbehindLength),
						    to = from + match.length,
						    before = str.slice(0, from),
						    after = str.slice(to);
	
						var args = [i, delNum];
	
						if (before) {
							++i;
							pos += before.length;
							args.push(before);
						}
	
						var wrapped = new Token(token, inside? _.tokenize(match, inside) : match, alias, match, greedy);
	
						args.push(wrapped);
	
						if (after) {
							args.push(after);
						}
	
						Array.prototype.splice.apply(strarr, args);
	
						if (delNum != 1)
							_.matchGrammar(text, strarr, grammar, i, pos, true, token);
	
						if (oneshot)
							break;
					}
				}
			}
		},
	
		tokenize: function(text, grammar, language) {
			var strarr = [text];
	
			var rest = grammar.rest;
	
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}
	
				delete grammar.rest;
			}
	
			_.matchGrammar(text, strarr, grammar, 0, 0, false);
	
			return strarr;
		},
	
		hooks: {
			all: {},
	
			add: function (name, callback) {
				var hooks = _.hooks.all;
	
				hooks[name] = hooks[name] || [];
	
				hooks[name].push(callback);
			},
	
			run: function (name, env) {
				var callbacks = _.hooks.all[name];
	
				if (!callbacks || !callbacks.length) {
					return;
				}
	
				for (var i=0, callback; callback = callbacks[i++];) {
					callback(env);
				}
			}
		}
	};
	
	var Token = _.Token = function(type, content, alias, matchedStr, greedy) {
		this.type = type;
		this.content = content;
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || "").length|0;
		this.greedy = !!greedy;
	};
	
	Token.stringify = function(o, language, parent) {
		if (typeof o == 'string') {
			return o;
		}
	
		if (_.util.type(o) === 'Array') {
			return o.map(function(element) {
				return Token.stringify(element, language, o);
			}).join('');
		}
	
		var env = {
			type: o.type,
			content: Token.stringify(o.content, language, parent),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language,
			parent: parent
		};
	
		if (o.alias) {
			var aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
			Array.prototype.push.apply(env.classes, aliases);
		}
	
		_.hooks.run('wrap', env);
	
		var attributes = Object.keys(env.attributes).map(function(name) {
			return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}).join(' ');
	
		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
	
	};
	
	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _self.Prism;
		}
	
		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data),
					lang = message.language,
					code = message.code,
					immediateClose = message.immediateClose;
	
				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}
	
		return _self.Prism;
	}
	
	//Get current script and highlight
	var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
	
	if (script) {
		_.filename = script.src;
	
		if (!_.manual && !script.hasAttribute('data-manual')) {
			if(document.readyState !== "loading") {
				if (window.requestAnimationFrame) {
					window.requestAnimationFrame(_.highlightAll);
				} else {
					window.setTimeout(_.highlightAll, 16);
				}
			}
			else {
				document.addEventListener('DOMContentLoaded', _.highlightAll);
			}
		}
	}
	
	return _self.Prism;
	
	})();
	
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Prism;
	}
	
	// hack for components to work correctly in node.js
	if (typeof global !== 'undefined') {
		global.Prism = Prism;
	}
	
	
	/* **********************************************
	     Begin prism-markup.js
	********************************************** */
	
	Prism.languages.markup = {
		'comment': /<!--[\s\S]*?-->/,
		'prolog': /<\?[\s\S]+?\?>/,
		'doctype': /<!DOCTYPE[\s\S]+?>/i,
		'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
		'tag': {
			pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
			greedy: true,
			inside: {
				'tag': {
					pattern: /^<\/?[^\s>\/]+/i,
					inside: {
						'punctuation': /^<\/?/,
						'namespace': /^[^\s>\/:]+:/
					}
				},
				'attr-value': {
					pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
					inside: {
						'punctuation': [
							/^=/,
							{
								pattern: /(^|[^\\])["']/,
								lookbehind: true
							}
						]
					}
				},
				'punctuation': /\/?>/,
				'attr-name': {
					pattern: /[^\s>\/]+/,
					inside: {
						'namespace': /^[^\s>\/:]+:/
					}
				}
	
			}
		},
		'entity': /&#?[\da-z]{1,8};/i
	};
	
	Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
		Prism.languages.markup['entity'];
	
	// Plugin to make entity title show the real entity, idea by Roman Komarov
	Prism.hooks.add('wrap', function(env) {
	
		if (env.type === 'entity') {
			env.attributes['title'] = env.content.replace(/&amp;/, '&');
		}
	});
	
	Prism.languages.xml = Prism.languages.markup;
	Prism.languages.html = Prism.languages.markup;
	Prism.languages.mathml = Prism.languages.markup;
	Prism.languages.svg = Prism.languages.markup;
	
	
	/* **********************************************
	     Begin prism-css.js
	********************************************** */
	
	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
			inside: {
				'rule': /@[\w-]+/
				// See rest below
			}
		},
		'url': /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
		'selector': /[^{}\s][^{};]*?(?=\s*\{)/,
		'string': {
			pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'property': /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
		'important': /\B!important\b/i,
		'function': /[-a-z0-9]+(?=\()/i,
		'punctuation': /[(){};:]/
	};
	
	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
	
	if (Prism.languages.markup) {
		Prism.languages.insertBefore('markup', 'tag', {
			'style': {
				pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
				lookbehind: true,
				inside: Prism.languages.css,
				alias: 'language-css',
				greedy: true
			}
		});
	
		Prism.languages.insertBefore('inside', 'attr-value', {
			'style-attr': {
				pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
				inside: {
					'attr-name': {
						pattern: /^\s*style/i,
						inside: Prism.languages.markup.tag.inside
					},
					'punctuation': /^\s*=\s*['"]|['"]\s*$/,
					'attr-value': {
						pattern: /.+/i,
						inside: Prism.languages.css
					}
				},
				alias: 'language-css'
			}
		}, Prism.languages.markup.tag);
	}
	
	/* **********************************************
	     Begin prism-clike.js
	********************************************** */
	
	Prism.languages.clike = {
		'comment': [
			{
				pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
				lookbehind: true
			},
			{
				pattern: /(^|[^\\:])\/\/.*/,
				lookbehind: true,
				greedy: true
			}
		],
		'string': {
			pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'class-name': {
			pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
			lookbehind: true,
			inside: {
				punctuation: /[.\\]/
			}
		},
		'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
		'boolean': /\b(?:true|false)\b/,
		'function': /[a-z0-9_]+(?=\()/i,
		'number': /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
		'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
		'punctuation': /[{}[\];(),.:]/
	};
	
	
	/* **********************************************
	     Begin prism-javascript.js
	********************************************** */
	
	Prism.languages.javascript = Prism.languages.extend('clike', {
		'keyword': /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
		'number': /\b(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|NaN|Infinity)\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
		// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
		'function': /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,
		'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
	});
	
	Prism.languages.insertBefore('javascript', 'keyword', {
		'regex': {
			pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
			lookbehind: true,
			greedy: true
		},
		// This must be declared before keyword because we use "function" inside the look-forward
		'function-variable': {
			pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,
			alias: 'function'
		},
		'constant': /\b[A-Z][A-Z\d_]*\b/
	});
	
	Prism.languages.insertBefore('javascript', 'string', {
		'template-string': {
			pattern: /`(?:\\[\s\S]|[^\\`])*`/,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /\$\{[^}]+\}/,
					inside: {
						'interpolation-punctuation': {
							pattern: /^\$\{|\}$/,
							alias: 'punctuation'
						},
						rest: Prism.languages.javascript
					}
				},
				'string': /[\s\S]+/
			}
		}
	});
	
	if (Prism.languages.markup) {
		Prism.languages.insertBefore('markup', 'tag', {
			'script': {
				pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
				lookbehind: true,
				inside: Prism.languages.javascript,
				alias: 'language-javascript',
				greedy: true
			}
		});
	}
	
	Prism.languages.js = Prism.languages.javascript;
	
	
	/* **********************************************
	     Begin prism-file-highlight.js
	********************************************** */
	
	(function () {
		if (typeof self === 'undefined' || !self.Prism || !self.document || !document.querySelector) {
			return;
		}
	
		self.Prism.fileHighlight = function() {
	
			var Extensions = {
				'js': 'javascript',
				'py': 'python',
				'rb': 'ruby',
				'ps1': 'powershell',
				'psm1': 'powershell',
				'sh': 'bash',
				'bat': 'batch',
				'h': 'c',
				'tex': 'latex'
			};
	
			Array.prototype.slice.call(document.querySelectorAll('pre[data-src]')).forEach(function (pre) {
				var src = pre.getAttribute('data-src');
	
				var language, parent = pre;
				var lang = /\blang(?:uage)?-(?!\*)([\w-]+)\b/i;
				while (parent && !lang.test(parent.className)) {
					parent = parent.parentNode;
				}
	
				if (parent) {
					language = (pre.className.match(lang) || [, ''])[1];
				}
	
				if (!language) {
					var extension = (src.match(/\.(\w+)$/) || [, ''])[1];
					language = Extensions[extension] || extension;
				}
	
				var code = document.createElement('code');
				code.className = 'language-' + language;
	
				pre.textContent = '';
	
				code.textContent = 'Loading…';
	
				pre.appendChild(code);
	
				var xhr = new XMLHttpRequest();
	
				xhr.open('GET', src, true);
	
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
	
						if (xhr.status < 400 && xhr.responseText) {
							code.textContent = xhr.responseText;
	
							Prism.highlightElement(code);
						}
						else if (xhr.status >= 400) {
							code.textContent = '✖ Error ' + xhr.status + ' while fetching file: ' + xhr.statusText;
						}
						else {
							code.textContent = '✖ Error: File does not exist or is empty';
						}
					}
				};
	
				if (pre.hasAttribute('data-download-link') && Prism.plugins.toolbar) {
					Prism.plugins.toolbar.registerButton('download-file', function () {
						var a = document.createElement('a');
						a.textContent = pre.getAttribute('data-download-link-label') || 'Download';
						a.setAttribute('download', '');
						a.href = src;
						return a;
					});
				}
	
				xhr.send(null);
			});
	
		};
	
		document.addEventListener('DOMContentLoaded', self.Prism.fileHighlight);
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background-pattern.e3839db4.png";

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/data-flow.461aab60.png";

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/footer-bg.464ba9d8.png";

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pub-sub-bg.fc9e147d.png";

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/recv.io.13759cba.png";

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _prismjs = __webpack_require__(705);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	__webpack_require__(606);
	
	__webpack_require__(666);
	
	var _pubSubBg = __webpack_require__(813);
	
	var _pubSubBg2 = _interopRequireDefault(_pubSubBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CodeSnippetSection = function (_React$Component) {
	    _inherits(CodeSnippetSection, _React$Component);
	
	    function CodeSnippetSection() {
	        _classCallCheck(this, CodeSnippetSection);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    CodeSnippetSection.prototype.componentDidMount = function componentDidMount() {
	
	        _prismjs2.default.highlightAllUnder(_reactDom2.default.findDOMNode(this));
	    };
	
	    CodeSnippetSection.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'component-code-snippet-section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'codesnip-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    this.codeSnippets
	                )
	            )
	        );
	    };
	
	    _createClass(CodeSnippetSection, [{
	        key: 'codeSnippets',
	        get: function get() {
	            var codeSnippets = this.props.codeSnippets;
	
	            var columnClass = Math.floor(12 / codeSnippets.length);
	
	            return codeSnippets.map(function (_ref) {
	                var title = _ref.title,
	                    code = _ref.code;
	
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-' + columnClass, key: title },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'code-snip' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-wrapper' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                title
	                            ),
	                            _react2.default.createElement('span', { className: 'title-underline' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'code' },
	                            _react2.default.createElement(
	                                'pre',
	                                null,
	                                _react2.default.createElement(
	                                    'code',
	                                    { className: 'language-js' },
	                                    code
	                                )
	                            )
	                        )
	                    )
	                );
	            });
	        }
	    }]);
	
	    return CodeSnippetSection;
	}(_react2.default.Component);
	
	exports.default = CodeSnippetSection;
	module.exports = exports['default'];

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Hero = __webpack_require__(481);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _PubSub = __webpack_require__(483);
	
	var _PubSub2 = _interopRequireDefault(_PubSub);
	
	var _LookFamiliar = __webpack_require__(482);
	
	var _LookFamiliar2 = _interopRequireDefault(_LookFamiliar);
	
	var _WildcardsQueues = __webpack_require__(484);
	
	var _WildcardsQueues2 = _interopRequireDefault(_WildcardsQueues);
	
	var _WithSomeExtras = __webpack_require__(485);
	
	var _WithSomeExtras2 = _interopRequireDefault(_WithSomeExtras);
	
	var _FullFeatureSet = __webpack_require__(480);
	
	var _FullFeatureSet2 = _interopRequireDefault(_FullFeatureSet);
	
	var _Footer = __webpack_require__(479);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePage = function HomePage(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'component-home-page' },
	        _react2.default.createElement(_Hero2.default, null),
	        _react2.default.createElement(_PubSub2.default, null),
	        _react2.default.createElement(_LookFamiliar2.default, null),
	        _react2.default.createElement(_WithSomeExtras2.default, null),
	        _react2.default.createElement(_FullFeatureSet2.default, null),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_Footer2.default, { user: props.user })
	        )
	    );
	};
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(694);
	
	var _recvIcon = __webpack_require__(814);
	
	var _recvIcon2 = _interopRequireDefault(_recvIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animation = function (_React$Component) {
	    _inherits(Animation, _React$Component);
	
	    function Animation(props) {
	        _classCallCheck(this, Animation);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            stage: 0
	        };
	        return _this;
	    }
	
	    Animation.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        setInterval(function () {
	
	            var stage = _this2.state.stage + 1;
	            if (stage > _this2.props.numStages) {
	                stage = 1;
	            }
	            _this2.setState({ stage: stage });
	        }, 1000);
	    };
	
	    Animation.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'component-animation stage-' + this.state.stage },
	            _react2.default.createElement(
	                'div',
	                { className: 'back-end server-one' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-drive', title: 'your back-end' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'back-end server-two' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-drive', title: 'your back-end' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'back-end server-three' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-drive', title: 'your back-end' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'recv' },
	                _react2.default.createElement('img', { src: _recvIcon2.default, title: 'recv.io' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'device laptop' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-laptop', title: 'laptop' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'device mobile' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-mobile', title: 'mobile' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'device tablet' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-tablet', title: 'tablet' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'device gamepad' },
	                _react2.default.createElement('div', { className: 'data' }),
	                _react2.default.createElement('span', { className: 'icon-gamepad2', title: 'gamepad' })
	            )
	        );
	    };
	
	    _createClass(Animation, null, [{
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                numStages: 12
	            };
	        }
	    }]);
	
	    return Animation;
	}(_react2.default.Component);
	
	exports.default = Animation;
	module.exports = exports['default'];

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Extra = function Extra(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'component-extra col-md-6' },
	    _react2.default.createElement(
	      'div',
	      { className: 'extras-inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'extras-icon' },
	        _react2.default.createElement(
	          'div',
	          { className: 'extras-icon-inner' },
	          _react2.default.createElement('i', { className: props.icon })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          ' ',
	          props.title,
	          ' '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          ' ',
	          props.subtitle,
	          ' '
	        )
	      )
	    )
	  );
	};
	
	exports.default = Extra;
	module.exports = exports['default'];

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(696);
	
	var _footerBg = __webpack_require__(812);
	
	var _footerBg2 = _interopRequireDefault(_footerBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var date = new Date().getFullYear();
	
	var Footer = function Footer() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'component-footer',
	            style: {
	                backgroundImage: 'url(' + _footerBg2.default + ')',
	                backgroundRepeat: "no-repeat",
	                backgroundPosition: "center"
	            } },
	        _react2.default.createElement(
	            'div',
	            { className: 'copy-right' },
	            _react2.default.createElement(
	                'span',
	                null,
	                ' \xA9 ',
	                date,
	                ' - recv.io'
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(697);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import WildcardsQueues from './WildcardsQueues';
	//
	// class FullFeatureSet extends React.Component {
	//
	//     constructor(props) {
	//         super(props);
	//         this.state = {
	//             clicked: false
	//         };
	//
	//         this.onClick = this.onClick.bind(this);
	//     }
	//
	//     onClick(e) {
	//         e.preventDefault();
	//         this.setState({clicked: true});
	//     }
	//
	//     render() {
	//
	//         if (this.state.clicked) {
	//             return <WildcardsQueues />
	//         }
	//         return (
	//             <div className="component-full-feature-set">
	//                 <span className="feature-text">see more examples <a href="#" onClick={this.onClick}>here</a>.</span>
	//             </div>
	//         );
	//     }
	// }
	
	
	var FullFeatureSet = function (_React$Component) {
	    _inherits(FullFeatureSet, _React$Component);
	
	    function FullFeatureSet(props) {
	        _classCallCheck(this, FullFeatureSet);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            email: '',
	            loading: false,
	            submitted: false
	        };
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onSubmit = _this.onSubmit.bind(_this);
	        return _this;
	    }
	
	    FullFeatureSet.prototype.onChange = function onChange(e) {
	        this.setState({ email: e.currentTarget.value });
	    };
	
	    FullFeatureSet.prototype.onSubmit = function onSubmit(e) {
	        var _this2 = this;
	
	        e.preventDefault();
	
	        this.setState({ loading: true, submitted: false }, function () {
	
	            var data = {
	                email: _this2.state.email,
	                api_key: 'xumUkWFKu6JM5wr_6ZQ_wQ'
	            };
	
	            var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
	
	            xhr.open('POST', 'https://api.convertkit.com/v3/forms/397809/subscribe');
	            xhr.onreadystatechange = function () {
	
	                if (xhr.readyState === XMLHttpRequest.DONE) {
	                    _this2.setState({
	                        loading: false,
	                        submitted: true
	                    });
	                } else {
	                    _this2.setState({
	                        loading: false,
	                        submitted: false
	                    });
	                }
	            };
	            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	            xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
	            xhr.send(JSON.stringify(data));
	        });
	    };
	
	    FullFeatureSet.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'component-full-feature-set' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'feature-text' },
	                        'We\'re currently in ',
	                        _react2.default.createElement(
	                            'strong',
	                            { style: { textDecoration: 'underline' } },
	                            'closed beta'
	                        ),
	                        '.',
	                        _react2.default.createElement('br', null),
	                        'Sign up below to get notified when we launch!'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-inline', id: 'launch-form', onSubmit: this.onSubmit },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement('input', {
	                                type: 'email',
	                                className: 'form-control',
	                                placeholder: 'your email address',
	                                value: this.state.email,
	                                onChange: this.onChange
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { disabled: this.state.loading, type: 'submit', className: 'btn' },
	                            this.state.submitted ? 'Success!' : 'Notify Me'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return FullFeatureSet;
	}(_react2.default.Component);
	
	exports.default = FullFeatureSet;
	module.exports = exports['default'];

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(698);
	
	var _backgroundPattern = __webpack_require__(810);
	
	var _backgroundPattern2 = _interopRequireDefault(_backgroundPattern);
	
	var _dataFlow = __webpack_require__(811);
	
	var _dataFlow2 = _interopRequireDefault(_dataFlow);
	
	var _Animation = __webpack_require__(477);
	
	var _Animation2 = _interopRequireDefault(_Animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'component-hero',
	            style: {
	                backgroundImage: 'url(' + _backgroundPattern2.default + ')',
	                backgroundRepeat: "no-repeat",
	                backgroundPosition: "center"
	            } },
	        _react2.default.createElement(
	            'div',
	            { className: 'tagline' },
	            _react2.default.createElement(
	                'div',
	                { className: 'tagline-inner' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'tagline-text' },
	                    'A durable, globally-distributed pub/sub network.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Multi-region scale'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Guaranteed message delivery'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Native MQTT and WebSocket support'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Both fan-out and queue-based messaging'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'buttons' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn launch', href: '#launch-form' },
	                        'Sign Up For Launch News'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'data-animation' },
	            _react2.default.createElement(_Animation2.default, null)
	        )
	    );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(699);
	
	var _recvIo = __webpack_require__(278);
	
	var _recvIo2 = _interopRequireDefault(_recvIo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LookFamiliar = function LookFamiliar(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'component-look-familiar' },
	        _react2.default.createElement(
	            'div',
	            { className: 'look-familiar' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'look familiar?'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        ' if you know ',
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'socket' },
	                            'socket.io'
	                        ),
	                        ', you know ',
	                        _react2.default.createElement('img', { src: _recvIo2.default })
	                    )
	                )
	            )
	        )
	    );
	};
	exports.default = LookFamiliar;
	module.exports = exports['default'];

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(700);
	
	var _recvIo = __webpack_require__(278);
	
	var _recvIo2 = _interopRequireDefault(_recvIo);
	
	var _CodeSnippetSection = __webpack_require__(369);
	
	var _CodeSnippetSection2 = _interopRequireDefault(_CodeSnippetSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var publish = '// in the browser...\nconst client = io(clientCredentials);\n\n// Send messages to the "greeting" topic\n\nclient.emit(\'greeting\', \'Oh, hi there!\', () => {\n\n\tconsole.log(\'message sent!\');\n});';
	
	var subscribe = '// in the browser...\nconst client = io(clientCredentials);\n\n// Listen for messages on the "greeting" topic\n\nclient.on(\'greeting\', message => {\n\n\tconsole.log(\'message received:\', message);\n});';
	
	var codeSnippets = [{
	    title: 'publish',
	    code: publish
	}, {
	    title: 'subscribe',
	    code: subscribe
	}];
	
	var PubSub = function PubSub() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'component-pub-sub' },
	        _react2.default.createElement(_CodeSnippetSection2.default, { codeSnippets: codeSnippets })
	    );
	};
	
	exports.default = PubSub;
	module.exports = exports['default'];

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CodeSnippetSection = __webpack_require__(369);
	
	var _CodeSnippetSection2 = _interopRequireDefault(_CodeSnippetSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wildcards = '\n// in the browser...\nconst client = io(clientCredentials);\n\n// Send messages to a multi-level topic\n\nclient.emit(\'event/greeting/english\', \'Oh, hi there!\');\n\n// listen to multiple topics at once with wildcards\n\nclient.on(\'event/+/+\', (message, [ event, language ]) => {\n        \n\tconsole.log(`${language} ${event} message: ${message}`);\n});\n\n';
	
	var queues = '\n// on your server...\nconst server = io(serverCredentials);\n\nserver.createQueue(queueName).then(queue => {\n    \n    // queues can use wildcards too\n    \n\tqueue.on(\'event/+/+\', (message, [event, language]) => {\n\n        // acknowledge the message when done\n        \n\t\tmessage.ack();\n\t});\n\n';
	
	var codeSnippets = [{
	    title: 'wildcards',
	    code: wildcards
	}, {
	    title: 'queues',
	    code: queues
	}];
	
	var WildcardsQueues = function WildcardsQueues() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'component-wildcards-queues' },
	        _react2.default.createElement(_CodeSnippetSection2.default, { codeSnippets: codeSnippets })
	    );
	};
	
	exports.default = WildcardsQueues;
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Extra = __webpack_require__(478);
	
	var _Extra2 = _interopRequireDefault(_Extra);
	
	__webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var extrasData = [{
	    icon: 'icon-earth',
	    title: 'Globaly Scalable',
	    subtitle: 'to connect users down the street or across continents'
	}, {
	    icon: 'icon-antenna',
	    title: 'Native MQTT',
	    subtitle: 'for IOT devices, with WebSocket support for browsers'
	}, {
	    icon: 'icon-cloud-download',
	    title: 'Guaranteed Delivery',
	    subtitle: 'by picking up where you left off after a reconnection'
	}, {
	    icon: 'icon-cloud-check',
	    title: 'Redundant Storage',
	    subtitle: 'saves your messages in at least three separate locations'
	}, {
	    icon: 'icon-list-numbered',
	    title: 'Causal Ordering',
	    subtitle: 'means messages always arrive in the correct order'
	}, {
	    icon: 'icon-stack',
	    title: 'Durable Queues',
	    subtitle: 'of all messages for asynchronous server-side processing'
	}, {
	    icon: 'icon-lock',
	    title: 'Topic Permissioning',
	    subtitle: 'gives you flexible, powerful auth schemes'
	}, {
	    icon: 'icon-plus',
	    title: 'Wildcard Subscriptions',
	    subtitle: 'retrieves messages for any topics that match'
	}];
	
	var WithSomeExtras = function (_Component) {
	    _inherits(WithSomeExtras, _Component);
	
	    function WithSomeExtras() {
	        _classCallCheck(this, WithSomeExtras);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    WithSomeExtras.prototype.renderExtras = function renderExtras() {
	        return extrasData.map(function (extra, index) {
	            return _react2.default.createElement(_Extra2.default, {
	                key: extra.title + '-' + index,
	                icon: extra.icon,
	                title: extra.title,
	                subtitle: extra.subtitle });
	        });
	    };
	
	    WithSomeExtras.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'component-with-some-extras ' },
	            _react2.default.createElement(
	                'div',
	                { className: 'extras-header' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'extras-text' },
	                        'with some extras...'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'extras row' },
	                this.renderExtras()
	            )
	        );
	    };
	
	    return WithSomeExtras;
	}(_react.Component);
	
	exports.default = WithSomeExtras;
	module.exports = exports['default'];

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HomePage = __webpack_require__(476);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _HomePage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e7282ba18ac9a7c45df8.js